import { Container, interfaces } from 'inversify'
import { ErrorPlatformEvent, interpret } from 'xstate-v4'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { ResendLastBookingConfirmationEmailFetch } from './fetch'
import {
  MachineContext,
  ResendLastBookingConfirmationService,
  returnBookingConfirmationRequestMachine,
} from './machine'

const resendLastBookingConfirmationContainer = new Container()
resendLastBookingConfirmationContainer.parent = rootContainer

resendLastBookingConfirmationContainer
  .bind<
    interfaces.Factory<ResendLastBookingConfirmationService>
  >('Factory<ResendLastBookingConfirmationService>')
  .toFactory<ResendLastBookingConfirmationService>(
    () => (ctx: MachineContext) => {
      const bookingConfirmationRequestMachine =
        returnBookingConfirmationRequestMachine()
      return interpret(
        bookingConfirmationRequestMachine
          .withContext({ ...bookingConfirmationRequestMachine.context, ...ctx })
          .withConfig({
            services: {
              requestResendBookingConfirmationEmail: async (_, { email }) =>
                await new ResendLastBookingConfirmationEmailFetch().requestResendBookingConfirmationEmail(
                  email,
                ),
            },
            actions: {
              logError: (_, _event: any) => {
                const event: ErrorPlatformEvent = _event
                event.data.name =
                  'bookingConfirmationRequestMachine ' + event.type + ' error'
                sentryCapture(event.data, rootContainer)
              },
            },
          }),
      )
    },
  )

export function getResendLastBookingConfirmationFactory() {
  return resendLastBookingConfirmationContainer.get<
    interfaces.Factory<ResendLastBookingConfirmationService>
  >('Factory<ResendLastBookingConfirmationService>')
}
